import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '@themes/aegix';
import { useAuthActions, useUser } from '@aegix/auth-identity';
import { LANGUAGE_OPTIONS, type SupportedLanguage } from '../i18n/config';
import type { SMSUser } from '../lib/sms-auth';

export function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const user = useUser<SMSUser>();
  const { updateLanguage } = useAuthActions<SMSUser>();

  const currentLanguage = i18n.language ? i18n.language.split('-')[0] : 'en';

  const handleChange = async (val: string) => {
    await i18n.changeLanguage(val);
    if (user?.id) {
      try {
        await updateLanguage(val);
      } catch (error) {
        console.error('Failed to sync language preference:', error);
      }
    }
  };

  return (
    <Box>
      <Text fontSize="sm" fontWeight="600" color="text.primary" mb={2}>
        {t('profile.language', 'Language')}
      </Text>
      <SelectInput
        label={t('profile.selectLanguage', 'Select Language')}
        name="language"
        option={LANGUAGE_OPTIONS}
        value={currentLanguage as SupportedLanguage}
        onChange={handleChange}
        e2eTitle="language-selector"
      />
    </Box>
  );
}

export default LanguageSelector;
